import React from "react";


const Title = ({ size = "", typeClass = "", content = "" }) => {
  const Heading = `h${size}`;
  return <Heading className={typeClass}> {content} </Heading>;
};

export default Title;
